module.exports =
{

  _init: function ()
  {
    this.onChangeItems()
  },

  onChangeItems: function ()
  {

    $('.js-item').not('.js-ignore').click(function ()
    {

      $('#items').val($(this).data('value'))

      $('#next').prop('disabled', false)

    }).addClass('js-ignore')

  }

}